import PlaceModel     from '@models/map/PlaceModel';
import FieldModel     from '@models/map/FieldModel';

/**
 * Ce qui empêche la suppression d'un type de point d'intérêt, dit en clair — ou `undefined` si rien
 * ne l'empêche.
 *
 * L'API refuse de supprimer un type encore lié, que ce soit à des points d'intérêts ou à des champs.
 * Plutôt que de laisser le geste échouer sur une erreur serveur, l'action reste affichée mais grisée
 * et porte cette phrase : elle nomme ce qui bloque et ce qu'il y a à défaire d'abord — deux gestes
 * différents, changer le type des uns, détacher les autres.
 *
 * `places` accepte un nombre OU un simple booléen, parce qu'on ne sait pas toujours combien : la
 * fiche d'un type connaît le compte exact, la liste sait seulement lesquels sont liés — l'API répond
 * ça en une requête (`exists[places]`), là où le compte par ligne en demanderait une par ligne.
 */
export default function placeTypeDeletionBlockedMessage(placeCount?: number | boolean, fieldCount?: number) {
	const places = placeCount === true
		? `des ${PlaceModel.localize('plural', 'l')}`
		: placeCount
			? `${placeCount} ${PlaceModel.localize(placeCount > 1 ? 'plural' : 'default', 'l')}`
			: undefined;

	const fields = fieldCount
		? `${fieldCount} ${FieldModel.localize(fieldCount > 1 ? 'plural' : 'default', 'l')}`
		: undefined;

	if (places && fields) {
		return `Ce type est porté par ${places} et regroupe ${fields}. Changez le type des uns et détachez les autres avant de le supprimer.`;
	}

	if (places) return `Ce type est porté par ${places}. Changez leur type avant de le supprimer.`;
	if (fields) return `Ce type regroupe ${fields}. Détachez-les avant de le supprimer.`;

	return undefined;
}
